import { useCallback, useMemo } from "react";
import { SearchOption, TypeaheadInput, TypeaheadInputComponent } from "@jsq/ds/core";
import { useGetArenasV2LazyQuery } from "~/graphql/supergraphHooks";
import * as styles from "../styles_vanilla.css";

type Props = {
  onSelect: (option: SearchOption) => void;
  onClear: () => void;
  inputRef: React.RefObject<TypeaheadInputComponent>;
  disabled?: boolean;
  placeholder?: string;
  initialSearchValue?: string;
};

export const ArenaTypeahead = ({
  onSelect,
  onClear,
  inputRef,
  disabled,
  placeholder,
  initialSearchValue,
}: Props) => {
  const [getArenas, { loading, error, data }] = useGetArenasV2LazyQuery({
    fetchPolicy: "no-cache",
  });

  const options: SearchOption[] = useMemo(
    () =>
      data?.arenas?.edges?.flatMap((e) =>
        e?.node ? [{ id: e.node.id, label: e.node.name, type: "arena" }] : [],
      ) ?? [],
    [data],
  );

  const handleSearch = useCallback(
    (term: string) => void getArenas({ variables: { searchTerm: term.trim() } }),
    [getArenas],
  );

  return (
    <TypeaheadInput
      label="Client"
      name="clientId"
      disabled={disabled}
      placeholder={placeholder ?? ""}
      className={styles.typeaheadField}
      options={options}
      isLoading={loading}
      isError={error !== undefined}
      onDebouncedSearch={handleSearch}
      onSelectOption={onSelect}
      onClearValue={onClear}
      initialSearchValue={initialSearchValue}
      ref={inputRef}
    />
  );
};
